/**
 * 批量忽略问题服务接口
 */
export const BatchIgnoreService = Symbol.for('BatchIgnoreService');

export interface BatchIgnoreService {
    /**
     * 批量忽略指定的问题
     * @param issueIds 问题ID数组
     * @returns Promise<void>
     */
    batchIgnoreIssues(issueIds: string[]): Promise<void>;
}
